import React from 'react';
export function Rosemary({
  className,
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <svg viewBox="0 0 100 100" className={className} style={style} stroke="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-69">
      <path d="M50 95Q45 50 50 5" strokeWidth="3" fill="none" strokeLinecap="round" data-id="element-70" />
      <path d="M50 15Q35 10 30 5" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-71" />
      <path d="M50 25Q65 20 70 15" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-72" />
      <path d="M49 35Q30 30 20 25" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-73" />
      <path d="M51 45Q70 40 80 35" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-74" />
      <path d="M48 55Q25 55 15 50" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-75" />
      <path d="M52 65Q75 65 85 60" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-76" />
      <path d="M49 75Q35 80 25 85" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-77" />
      <path d="M51 85Q65 90 75 95" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-78" />
    </svg>;
}